import { LASER_KPI_PREVIEW_USERS } from "./kpi/access.mjs";

export default {
    title: "Laser",
    icon: "mdi-laser-pointer",
    groups: ["Tecnici", "Laser", "Milkrun"],
    submenu: [
        {
            title: "KPI reparto laser",
            users: LASER_KPI_PREVIEW_USERS,
            route: { name: "laser-kpi-reparto" },
            icon: "mdi-chart-box-outline",
            groups: ["Tecnici", "Laser", "Milkrun", "Schedulazione", "Amministrazione"],
        },
        {
            title: "Programmi",
            route: { name: "laser-programmi" },
            badge: { url: "/laser/programmi/conteggio_dafare/", tooltip: "Conteggio Programmi da fare" },
            groups: ["Tecnici"],
        },
        {
            title: "Da Nestare",
            route: { name: "laser-danestare-v2" },
            badge: { url: "/laser/riepilogo-v2/conteggio/", tooltip: "Totale ODP da nestare" },
            groups: ["Tecnici", "Laser"],
        },
        {
            title: "Taglio laser",
            route: { name: "laser-intaglio-oseon" },
            badge: { url: "/oseon/jobs-overview/", tooltip: "Conteggio Jobs Oseon" },
            groups: ["Tecnici", "Laser", "Milkrun"],
        },
        {
            title: "Laser lamiera",
            route: { name: "laser-intaglio-oseon-v2" },
            icon: "mdi-laser-pointer",
            test: true,
            ariaLabel: "Laser lamiera TEST, pagina di test",
            groups: ["Tecnici", "Laser", "Milkrun"],
        },
        {
            title: "Nc Sbc",
            route: { name: "laser-problemi-sbancatura" },
            badge: {
                url: "/laser/sbancalatura-problemi/conteggio/?age_days=7",
                tooltip: "Conteggio NC SBC",
            },
            groups: ["Tecnici", "Laser", "Milkrun"],
        },
        {
            title: "Analisi Fermi",
            route: { name: "laser-head-collision-analysis" },
            groups: ["Tecnici", "Laser"],
        },
        {
            title: "Trustore",
            route: { name: "laser-trustore-v2" },
            groups: ["Tecnici", "Laser", "Milkrun"],
        },
        {
            title: "SBC",
            route: { name: "laser-sbc-v4-table-1" },
            badge: { url: "/laser/sbancalatura/conteggio-fogli/", tooltip: "Fogli da sbancalare" },
            groups: ["Tecnici", "Laser", "Milkrun", "Amministrazione"],
        },
        {
            title: "Da Ubicare",
            route: { name: "laser-daubicare" },
            badge: { url: "/laser/sbancalatura/conteggio_da_ubicare/", tooltip: "Conteggio ODP da ubicare" },
            groups: ["Tecnici", "Laser", "Milkrun"],
        },
    ],
};
